export class EventEmitter<TEvent = any> {
  static biEvents = {
    PLATFORM_WORKER_SPAWN: 123,
    PLATFORM_APP_RUNNER_INIT_APP_API: 124,
    PLATFORM_APP_RUNNER_RUN_APP: 125,
    PLATFORM_APP_RUNNER_REMOVE_APP: 126,
    PLATFORM_WORKER_APP_BUNDLE_LOAD: 127,
    PLATFORM_WORKER_APP_BUNDLE_EXECUTE: 128,
    PLATFORM_IFRAME_INIT: 129,
    PLATFORM_APP_API_INIT: 130,
    PLATFORM_APP_API_GET: 131,
  };

  static EventSteps = {
    Start: 'start',
    End: 'end',
    Error: 'error',
  };

  private uid = 0;
  private callbacks: Map<any, (event: TEvent) => void> = new Map();
  private inTransaction = false;
  private isSilent = false;
  private queue: TEvent[] = [];

  silent(isSilent = true) {
    this.isSilent = isSilent;
  }

  startTransaction() {
    this.inTransaction = true;
  }

  commit() {
    this.inTransaction = false;

    const queue = this.queue;
    this.queue = [];

    if (!this.isSilent) {
      queue.forEach((event) => {
        this.notify(event);
      });
    }
  }

  notify(event: TEvent) {
    if (this.isSilent) {
      return;
    }

    if (this.inTransaction) {
      this.queue.push(event);
    } else {
      this.callbacks.forEach((callback) => {
        callback(event);
      });
    }
  }

  subscribe(callback: (event: TEvent) => void) {
    const uid = this.uid++;

    this.callbacks.set(uid, callback);

    return () => {
      this.callbacks.delete(uid);
    };
  }

  notifyWithStep(event: TEvent, step: string) {
    this.notify({
      ...event,
      meta: {
        ...(event as any).meta,
        step,
      },
    });
  }

  async withEvent<TResult = any>(
    event: TEvent,
    cb: () => TResult | Promise<TResult>,
  ): Promise<TResult> {
    // TODO: wrap with try/catch
    let result = cb();

    if (result && result.hasOwnProperty('then')) {
      try {
        this.notifyWithStep(event, EventEmitter.EventSteps.Start);

        result = await result;

        this.notifyWithStep(event, EventEmitter.EventSteps.End);

        return result;
      } catch (e) {
        this.notifyWithStep(
          {
            ...event,
            meta: {
              ...(event as any).meta,
              error: e,
            },
          },
          EventEmitter.EventSteps.Error,
        );

        throw e;
      }
    } else {
      this.notify(event);

      return result;
    }
  }
}
